// extracted by mini-css-extract-plugin
export default {"wrapper":"TitleAndDesc_wrapper__4f3fp","title":"TitleAndDesc_title__QsTQ0","description":"TitleAndDesc_description__q8NNi"};